import React from 'react';
import { Flex, Button, Image, Link } from '@chakra-ui/react';
import checkIcon from '/assets/images/icons/check.svg';
import { useTranslation } from 'react-i18next';

interface AnalysisFilterActionsProps {
  onCancel: () => void;
  onApply: () => void;
}

const AnalysisFilterActions: React.FC<AnalysisFilterActionsProps> = ({ onCancel, onApply }) => {
  const { t } = useTranslation();

  return (
    <Flex w="100%" justifyContent="end" mt="25px" gap="20px" alignItems="center">
      <Link
        data-testid="analysis-filter-cancel"
        fontSize="18px"
        fontWeight={400}
        lineHeight="normal"
        color="#2B4956"
        onClick={onCancel}
        textDecoration="underline"
      >
        {t('general.cancel')}
      </Link>            
      <Button
        colorScheme="alea"
        variant="solid"
        size="lg"
        onClick={onApply}
        w="100px"
        h="50px"
        borderRadius="20px"
      >
        <Image
          src={checkIcon}
          alt="Icon"
          h="21px"
        />
      </Button>
    </Flex>
  );
};

export default AnalysisFilterActions; 